import { render } from "./SelectSettingAccountingCode.vue?vue&type=template&id=5d3c92d7"
import script from "./SelectSettingAccountingCode.vue?vue&type=script&lang=js"
export * from "./SelectSettingAccountingCode.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__